import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { toJSDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-premium-invites',
  templateUrl: './premium-invites.component.html',
  styleUrls: ['./premium-invites.component.scss'],
})
export class PremiumInvitesComponent {
  @Input() addOnId: number;
  @Input() isFromPayment: boolean = false;
  @Input() videoId: number;
  @Input() videoPath: any;
  @Input() isFromCategory: any = false;
  @Input() nameEnglish: any;
  isShowButton = false;
  constructor(
    private activeModel: NgbActiveModal,
    public sanitizer: DomSanitizer,
    private _router: Router,
    public sharedService: SharedService,
  ) {
    this.sanitizer = sanitizer;
  }
  ngOnInit() {
    this.videoURL();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isShowButton = true;
    }, 2000);
  }
  close() {
    this.activeModel.close(false);
  }
  startCustomizing() {
    let encryptedqueryparams: { videoId: any; };
    encryptedqueryparams = {
      videoId: this.videoId
    };
    const route = `/preview/${this.nameEnglish.replace(/ +/g, "-")}/video/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`;
    window.open(route, '_blank');
    this.activeModel.close(true);
  }
  videoURL() {
    this.videoPath = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoPath);
  }
}
